import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { envConfig } from '../../../../config';
import { REPORT_REQUEST_ID_LIST } from './report-constant';

class ReportServiceClass {
  getReport = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: `v1/merchant/company-admin/reports/daily/${params.data.date}/documents`,
      id: params.id,
      config: {
        params: {
          offset: params.data.offset,
          limit: params.data.limit,
          shopId: params.data.shopId
        }
      }
    });
  }

  getDownload = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + `v1/merchant/company-admin/reports/daily/${params.data.date}`,
      config: { headers: { 'document-token': params.data.docToken } },
      id: REPORT_REQUEST_ID_LIST.GET_DOWNLOAD
    });
  }

  getConfirmEmail = async () => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/reports/confirm-email',
      id: REPORT_REQUEST_ID_LIST.GET_CONFIRM_EMAIL
    });
  }

  postEmailVatAddress = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/reports/email-vataddress',
      data: params.data,
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_VAT_ADDRESS
    });
  }

  postEmailShop = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/reports/email-shop',
      data: params.data,
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_SHOP
    });
  }

  postEmailResend = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/reports/resend-email',
      data: params.data,
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_RESEND
    });
  }

  verifyEmail = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + `v1/merchant/company-admin/reports/email-verification/${params.data}`,
      id: params.id
    });
  }

  patchReportType = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/reports/report-type',
      data: params.data,
      id: REPORT_REQUEST_ID_LIST.PATCH_REPORT_TYPE
    });
  }

  getShopList = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/shopList',
      id: REPORT_REQUEST_ID_LIST.GET_SHOP_LIST
    });
  }
}
export const ReportService = new ReportServiceClass();
